/*
 * SPDX-FileCopyrightText: 2020 CERN.
 * SPDX-License-Identifier: MIT
 */

import defaultComponents from "./defaultComponents";
import { createSearchAppInit } from "./util";

export { defaultComponents, createSearchAppInit };
